// @ts-ignore
import avatar0 from 'url:../img/avatar0.jpg';
// @ts-ignore
import avatar1 from 'url:../img/avatar1.jpg';
// @ts-ignore
import avatar2 from 'url:../img/avatar2.jpg';
// @ts-ignore
import avatar3 from 'url:../img/avatar3.jpg';

import {
  type ActiveGameInfo,
  ensureUser,
  getApiBaseUrl,
  getLoginToken,
  resetApiToken,
  resetLoginToken,
  setLoginToken,
  updateMe,
  uploadMeAvatar,
  UserPublic,
} from './user';
import {
  deletePracticeRecord,
  enterPracticeRecord,
  listPracticeRecords,
  patchPracticeRecord,
  sharePracticeRecord,
  type PracticeRecordSummary,
} from './practice-record-api';
import { createPaipuShare, deletePaipu, listMyPaipus, type PaipuListItem } from './paipu-api';
import {
  AiBillingItem,
  AiPref,
  UserPayChannel,
  UserPayOrder,
  UserPayPackage,
  createPayOrder,
  fetchPayConfig,
  fetchPayOrder,
  fetchAiBilling,
  fetchAiSettings,
  fetchAiRules,
  setAiDefault,
  setAiOfficialModel,
  setAiRules,
} from './ai-settings-api';
import { Ecc, QrCode } from './lib/qrcodegen';
import { getBasePath } from './ws-url';
import { setupDesignCanvasScale } from './design-canvas';
import { ensurePwaManifestLink } from './pwa-manifest';

ensurePwaManifestLink();

const avatars = [avatar0, avatar1, avatar2, avatar3];

const meRoot = document.getElementById('me-root') as HTMLElement | null;
const meCanvasWrap = document.getElementById('me-canvas-wrap') as HTMLElement | null;
const meCanvas = document.getElementById('me-canvas') as HTMLElement | null;
const meCanvasScale = setupDesignCanvasScale({ root: meRoot, wrap: meCanvasWrap, canvas: meCanvas });
const meCanvasScaleNeedsManualSchedule = typeof ResizeObserver === 'undefined';

function scheduleMeCanvasScale(): void {
  if (!meCanvasScaleNeedsManualSchedule) return;
  meCanvasScale?.schedule();
}
window.addEventListener(
  'beforeunload',
  () => {
    meCanvasScale?.destroy();
  },
  { once: true },
);

const statusEl = document.getElementById('status') as HTMLElement;
const contentEl = document.getElementById('content') as HTMLElement;
type MeTab = 'account' | 'pay' | 'replay' | 'practice' | 'security';

const meTabAccountBtn = document.getElementById('me-tab-account') as HTMLButtonElement;
const meTabPayBtn = document.getElementById('me-tab-pay') as HTMLButtonElement;
const meTabReplayBtn = document.getElementById('me-tab-replay') as HTMLButtonElement;
const meTabPracticeBtn = document.getElementById('me-tab-practice') as HTMLButtonElement;
const meTabSecurityBtn = document.getElementById('me-tab-security') as HTMLButtonElement;
const mePanelAccountEl = document.getElementById('me-panel-account') as HTMLElement;
const mePanelPayEl = document.getElementById('me-panel-pay') as HTMLElement;
const mePanelReplayEl = document.getElementById('me-panel-replay') as HTMLElement;
const mePanelPracticeEl = document.getElementById('me-panel-practice') as HTMLElement;
const mePanelSecurityEl = document.getElementById('me-panel-security') as HTMLElement;
const replayRefreshBtn = document.getElementById('replay-refresh') as HTMLButtonElement;
const replayListEl = document.getElementById('replay-list') as HTMLElement;
const replayFilterRoomAllBtn = document.getElementById('replay-filter-room-all') as HTMLButtonElement;
const replayFilterRoomNewbieBtn = document.getElementById('replay-filter-room-newbie') as HTMLButtonElement;
const replayFilterRoomFriendBtn = document.getElementById('replay-filter-room-friend') as HTMLButtonElement;
const replayFilterVariantAllBtn = document.getElementById('replay-filter-variant-all') as HTMLButtonElement;
const replayFilterVariantXuezhanBtn = document.getElementById('replay-filter-variant-xuezhan') as HTMLButtonElement;
const replayFilterVariantGuobiaoBtn = document.getElementById('replay-filter-variant-guobiao') as HTMLButtonElement;
const replayFilterShareAllBtn = document.getElementById('replay-filter-share-all') as HTMLButtonElement;
const replayFilterShareSharedBtn = document.getElementById('replay-filter-share-shared') as HTMLButtonElement;
const replayFilterShareUnsharedBtn = document.getElementById('replay-filter-share-unshared') as HTMLButtonElement;
const practiceRefreshBtn = document.getElementById('practice-refresh') as HTMLButtonElement;
const practiceListEl = document.getElementById('practice-list') as HTMLElement;

const nickInput = document.getElementById('nick') as HTMLInputElement;
const matchPointsEl = document.getElementById('match-points') as HTMLElement | null;
const avatarCurrentImageEl = document.getElementById('avatar-current-image') as HTMLImageElement;
const avatarCurrentTitleEl = document.getElementById('avatar-current-title') as HTMLElement;
const avatarCurrentDescEl = document.getElementById('avatar-current-desc') as HTMLElement;
const avatarUploadBtn = document.getElementById('avatar-upload-btn') as HTMLButtonElement;
const avatarUploadInput = document.getElementById('avatar-upload-input') as HTMLInputElement;
const bgmEnabledInput = document.getElementById('bgm-enabled') as HTMLInputElement;
const sfxEnabledInput = document.getElementById('sfx-enabled') as HTMLInputElement;
const saveBtn = document.getElementById('save') as HTMLButtonElement;

const loginTokenInput = document.getElementById('login-token') as HTMLInputElement;
const loginTokenVisibilityBtn = document.getElementById('login-token-visibility') as HTMLButtonElement;
const copyLoginBtn = document.getElementById('copy-login') as HTMLButtonElement;
const resetLoginBtn = document.getElementById('reset-login') as HTMLButtonElement;
const resetApiBtn = document.getElementById('reset-api') as HTMLButtonElement;

const aiBillingPointsEl = document.getElementById('ai-billing-points') as HTMLElement;
const aiBillingListEl = document.getElementById('ai-billing-list') as HTMLElement;
const aiBillingRefreshBtn = document.getElementById('ai-billing-refresh') as HTMLButtonElement;
const payModeTipEl = document.getElementById('pay-mode-tip') as HTMLElement;
const payPackageOptionsEl = document.getElementById('pay-package-options') as HTMLElement;
const payChannelOptionsEl = document.getElementById('pay-channel-options') as HTMLElement;
const payCreateOrderBtn = document.getElementById('pay-create-order') as HTMLButtonElement;
const payOrderStatusEl = document.getElementById('pay-order-status') as HTMLElement;
const payQrPanelEl = document.getElementById('pay-qr-panel') as HTMLElement;
const payQrTitleEl = document.getElementById('pay-qr-title') as HTMLElement;
const payQrImageEl = document.getElementById('pay-qr-image') as HTMLImageElement;
const payQrTipEl = document.getElementById('pay-qr-tip') as HTMLElement;
const payActionStatusEl = document.getElementById('pay-action-status') as HTMLElement;
const payCreateLoadingMaskEl = document.getElementById('pay-create-loading-mask') as HTMLElement;
const payCreateLoadingTextEl = document.getElementById('pay-create-loading-text') as HTMLElement;
const aiOfficialHintEl = document.getElementById('ai-official-hint') as HTMLElement;
const aiOfficialModelOptionsEl = document.getElementById('ai-official-model-options') as HTMLElement;
const aiRulesSourceEl = document.getElementById('ai-rules-source') as HTMLElement;
const aiRulesDirtyEl = document.getElementById('ai-rules-dirty') as HTMLElement;
const aiRulesCountEl = document.getElementById('ai-rules-count') as HTMLElement;
const aiRulesTextarea = document.getElementById('ai-rules-textarea') as HTMLTextAreaElement;
const aiRulesSaveBtn = document.getElementById('ai-rules-save') as HTMLButtonElement;
const aiRulesResetBtn = document.getElementById('ai-rules-reset') as HTMLButtonElement;

const modal = document.getElementById('modal') as HTMLElement;
const modalTitle = document.getElementById('modal-title') as HTMLElement;
const modalText = document.getElementById('modal-text') as HTMLElement;
const modalBody = document.getElementById('modal-body') as HTMLElement;
const modalClose = document.getElementById('modal-close') as HTMLButtonElement;

type OfficialModelOption = {
  gatewayId: string;
  gatewayName: string;
  modelId: string;
  isSystemDefault: boolean;
};

let currentUser: UserPublic | null = null;
let selectedAvatarIndex: number = 0;
const MAX_AVATAR_FILE_BYTES = 5 * 1024 * 1024;

let aiOfficialModels: Array<string> = [];
let aiOfficialModelOptions: Array<OfficialModelOption> = [];
let aiDefault: AiPref = { source: 'official', profileId: null };
let aiOfficial: {
  model: string;
  globalDefaultModel?: string;
  overrideModel?: string;
  gatewayId?: string;
  points: number;
  enabled: boolean;
  canUse: boolean;
  configured: boolean;
} = {
  model: 'gpt-5.2',
  points: 0,
  enabled: false,
  canUse: false,
  configured: false,
};
let aiBillingItems: Array<AiBillingItem> = [];
let payMode: 'manual' | 'xorpay' = 'manual';
let payPackages: Array<UserPayPackage> = [];
let payChannels: Array<UserPayChannel> = ['alipay', 'wechat_native'];
let paySelectedPackageId = '';
let paySelectedChannel: UserPayChannel = 'alipay';
let payCurrentOrder: UserPayOrder | null = null;
let payPollingTimer: number | null = null;
let payConfigError: string | null = null;
const payQrImageCache = new Map<string, string>();
let uiBusy = false;
let apiOriginCache: string | null = null;
let activeTab: MeTab = 'account';
let aiSettingsLoaded = false;
let payConfigLoaded = false;
let aiBillingLoaded = false;
let aiRulesLoaded = false;
let aiRulesDirty = false;
let payTabLoadPromise: Promise<void> | null = null;
let replayTabLoadPromise: Promise<void> | null = null;
let practiceTabLoadPromise: Promise<void> | null = null;
let securityTabLoadPromise: Promise<void> | null = null;
let tabsInitialized = false;
let replayRecordsLoaded = false;
let replayRecords: Array<PaipuListItem> = [];
let replayRoomFilter: 'all' | 'newbie' | 'friend' = 'all';
let replayVariantFilter: 'all' | 'xuezhan' | 'guobiao' = 'all';
let replayShareFilter: 'all' | 'shared' | 'unshared' = 'all';
let practiceRecordsLoaded = false;
let practiceRecordsMine: Array<PracticeRecordSummary> = [];
let practiceRecordsShared: Array<PracticeRecordSummary> = [];

let aiRules: { source: 'user' | 'global'; global: string; user: string | null } = { source: 'global', global: '', user: null };
let aiRulesSavedText = '';

const EYE_ICON_SVG =
  '<svg viewBox="0 0 24 24"><path d="M2.06 12C3.08 8.95 6.2 6 12 6s8.92 2.95 9.94 6c-1.02 3.05-4.14 6-9.94 6s-8.92-2.95-9.94-6Z"></path><circle cx="12" cy="12" r="3"></circle></svg>';
const EYE_OFF_ICON_SVG =
  '<svg viewBox="0 0 24 24"><path d="M10.73 5.08A10.96 10.96 0 0 1 12 5c5.8 0 8.92 2.95 9.94 6a11.87 11.87 0 0 1-2.06 3.36"></path><path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"></path><path d="M17.94 17.94A11.91 11.91 0 0 1 12 19c-5.8 0-8.92-2.95-9.94-6a11.9 11.9 0 0 1 4.24-5.32"></path><path d="m2 2 20 20"></path></svg>';

function openModal(title: string, text: string, body: HTMLElement): void {
  modalTitle.textContent = title;
  modalText.textContent = text;
  modalBody.innerHTML = '';
  modalBody.appendChild(body);
  modal.classList.add('open');
}

function closeModal(): void {
  modal.classList.remove('open');
}

function parseMeTabFromHash(): MeTab {
  const raw = String(window.location.hash ?? '')
    .replace(/^#/, '')
    .trim()
    .toLowerCase();
  if (raw === 'pay' || raw === 'ai' || raw === 'billing') return 'pay';
  if (raw === 'replay' || raw === 'paipu' || raw === '牌谱') return 'replay';
  if (raw === 'practice' || raw === 'branch' || raw === 'branches') return 'practice';
  if (raw === 'security' || raw === 'safe' || raw === 'advanced') return 'security';
  return 'account';
}

function tabHash(tab: MeTab): string {
  return `#${tab}`;
}

function renderMeTabs(tab: MeTab): void {
  const tabs: Array<{ key: MeTab; btn: HTMLButtonElement; panel: HTMLElement }> = [
    { key: 'account', btn: meTabAccountBtn, panel: mePanelAccountEl },
    { key: 'pay', btn: meTabPayBtn, panel: mePanelPayEl },
    { key: 'replay', btn: meTabReplayBtn, panel: mePanelReplayEl },
    { key: 'practice', btn: meTabPracticeBtn, panel: mePanelPracticeEl },
    { key: 'security', btn: meTabSecurityBtn, panel: mePanelSecurityEl },
  ];
  for (const item of tabs) {
    const on = item.key === tab;
    item.btn.classList.toggle('is-active', on);
    item.btn.setAttribute('aria-selected', on ? 'true' : 'false');
    item.btn.tabIndex = on ? 0 : -1;
    item.panel.hidden = !on;
  }
  scheduleMeCanvasScale();
}

function setLoginStatusIfIdle(expected: string): void {
  if (!currentUser) return;
  if (statusEl.textContent === expected) {
    statusEl.textContent = `已登录：${currentUser.nickname}`;
  }
}

function setPayActionStatus(text: string): void {
  payActionStatusEl.textContent = String(text ?? '').trim();
}

function bindSecretToggle(input: HTMLInputElement, button: HTMLButtonElement, label: string): void {
  const sync = () => {
    const visible = input.type !== 'password';
    button.classList.toggle('is-visible', visible);
    button.setAttribute('aria-pressed', visible ? 'true' : 'false');
    button.setAttribute('aria-label', `${visible ? '隐藏' : '显示'}${label}`);
  };
  input.type = 'password';
  button.onclick = () => {
    input.type = input.type === 'password' ? 'text' : 'password';
    sync();
  };
  sync();
}

function createSecretToggleButton(input: HTMLInputElement, label: string): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'secret-toggle';
  button.innerHTML = `<span class="secret-icon icon-show" aria-hidden="true">${EYE_ICON_SVG}</span><span class="secret-icon icon-hide" aria-hidden="true">${EYE_OFF_ICON_SVG}</span>`;
  bindSecretToggle(input, button, label);
  return button;
}

function setPayCreateLoading(active: boolean, text?: string): void {
  payCreateLoadingMaskEl.hidden = !active;
  if (text !== undefined) {
    payCreateLoadingTextEl.textContent = String(text ?? '').trim() || '正在创建支付订单…';
  }
}

function setPayModeTip(text: string): void {
  const tip = String(text ?? '').trim();
  payModeTipEl.textContent = tip;
  payModeTipEl.hidden = !tip;
}

function updateAiRulesDraftMeta(): void {
  const text = aiRulesTextarea.value ?? '';
  const count = Array.from(text).length;
  aiRulesCountEl.textContent = `${count} 字`;
  aiRulesDirty = aiRulesLoaded && text !== aiRulesSavedText;
  aiRulesDirtyEl.textContent = aiRulesDirty ? '有未保存修改' : '未修改';
  aiRulesDirtyEl.classList.toggle('warn', aiRulesDirty);
  if (!uiBusy) {
    aiRulesSaveBtn.disabled = !aiRulesDirty;
    aiRulesResetBtn.disabled = !aiRules.user;
  }
}

function formatPoints(raw: number): string {
  const n = Number.isFinite(raw) ? Math.trunc(raw) : 0;
  return new Intl.NumberFormat('zh-CN').format(n);
}

function formatTime(raw: number): string {
  const n = Number.isFinite(raw) ? Math.trunc(raw) : 0;
  if (n <= 0) return '-';
  const d = new Date(n);
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  const hh = `${d.getHours()}`.padStart(2, '0');
  const mm = `${d.getMinutes()}`.padStart(2, '0');
  return `${y}-${m}-${day} ${hh}:${mm}`;
}

function formatSigned(raw: number | null): string {
  if (!Number.isFinite(raw ?? NaN)) return '--';
  const n = Math.trunc(raw as number);
  if (n > 0) return `+${formatPoints(n)}`;
  if (n < 0) return `-${formatPoints(Math.abs(n))}`;
  return '0';
}

function practiceStatusLabel(item: PracticeRecordSummary): string {
  if (item.templateStatus === 'disabled' && item.status !== 'active') return '已失效';
  if (item.status === 'ready') return '可进入';
  if (item.status === 'active') return '进行中';
  if (item.status === 'done') return '已完成';
  return '锁定中';
}

function practiceRoomLabel(roomType: string | null): string {
  if (roomType === 'newbie') return '新手房';
  if (roomType === 'friend') return '好友房';
  return '对局';
}

function paipuRoomLabel(roomType: string | null): string {
  return practiceRoomLabel(roomType);
}

function paipuVariantLabel(variant: string | null | undefined): string {
  if (variant === 'guobiao') return '国际标准';
  return '血战到底';
}

function paipuResultLabel(item: PaipuListItem): string {
  const delta = item.myResult.pointsDelta ?? item.myResult.deltaBeans;
  const parts = [`结果：${formatSigned(delta ?? null)}`];
  if (item.rules?.variant === 'guobiao' && Number.isFinite(item.myResult.ruleScoreDelta ?? NaN)) {
    parts.push(`规则分 ${formatSigned(item.myResult.ruleScoreDelta ?? null)}`);
  }
  if (item.myResult.finalBeans !== null) parts.push(`当前 ${formatPoints(item.myResult.finalBeans)}`);
  return parts.join(' · ');
}

function practiceSceneLabel(scene: PracticeRecordSummary['scene']): string {
  if (scene === 'turn') return '弃牌决策';
  if (scene === 'claim') return '响应决策';
  if (scene === 'swap3') return '换三张';
  if (scene === 'dingque') return '定缺';
  return '局面快照';
}

function practiceShareStateLabel(state: PracticeRecordSummary['shareState']): string {
  return state === 'shared' ? '已分享' : '仅自己';
}

function normalizeActiveGame(raw: any): ActiveGameInfo | null {
  const gameId = typeof raw?.gameId === 'string' ? raw.gameId.trim() : '';
  if (!gameId) return null;
  const seatRaw = Number(raw?.seat);
  const seat = Number.isFinite(seatRaw) ? Math.trunc(seatRaw) : -1;
  if (seat < 0 || seat > 3) return null;
  const roomType = typeof raw?.roomType === 'string' ? raw.roomType.trim() || null : null;
  return { gameId, seat, roomType };
}

function practiceActiveGameUrl(active: ActiveGameInfo): string {
  const basePath = getBasePath();
  const room = active.roomType === 'newbie' ? '&room=newbie' : '';
  return `${basePath}hand/?gameId=${encodeURIComponent(active.gameId)}${room}`;
}

function practiceCanEnter(item: PracticeRecordSummary): boolean {
  if (item.status === 'locked') return false;
  if (item.templateStatus === 'disabled' && item.status !== 'active') return false;
  return true;
}

function practiceEnterLabel(item: PracticeRecordSummary): string {
  if (item.templateStatus === 'disabled' && item.status !== 'active') return '已失效';
  if (item.status === 'locked') return '未解锁';
  if (item.status === 'active') return '继续';
  if (item.status === 'done') return '再来一局';
  return '进入';
}

function practiceCanShare(item: PracticeRecordSummary): boolean {
  if (item.status === 'locked') return false;
  if (item.templateStatus === 'disabled') return false;
  return true;
}

function buildAppUrl(path: string): string {
  const basePath = getBasePath();
  const normalizedBase = basePath.endsWith('/') ? basePath : `${basePath}/`;
  const relative = String(path ?? '').replace(/^\/+/, '');
  return new URL(`${normalizedBase}${relative}`, window.location.origin).toString();
}

function replacePracticeRecord(next: PracticeRecordSummary): void {
  const update = (items: Array<PracticeRecordSummary>): Array<PracticeRecordSummary> => {
    let found = false;
    const mapped = items.map((item) => {
      if (item.recordId !== next.recordId) return item;
      found = true;
      return next;
    });
    return found ? mapped : items;
  };
  if (next.recordOrigin === 'shared_collected') {
    practiceRecordsShared = update(practiceRecordsShared);
  } else {
    practiceRecordsMine = update(practiceRecordsMine);
  }
}

function removePracticeRecord(recordId: string): void {
  practiceRecordsMine = practiceRecordsMine.filter((item) => item.recordId !== recordId);
  practiceRecordsShared = practiceRecordsShared.filter((item) => item.recordId !== recordId);
}

function openPracticeActiveGameModal(active: ActiveGameInfo): void {
  const body = document.createElement('div');
  body.className = 'field';

  const line1 = document.createElement('div');
  line1.className = 'sub';
  line1.textContent = `当前正在进行：${practiceRoomLabel(active.roomType)}（座位 ${active.seat + 1}）。`;
  body.appendChild(line1);

  const line2 = document.createElement('div');
  line2.className = 'sub';
  line2.textContent = '为避免多桌并发，请先回到当前牌局。';
  body.appendChild(line2);

  const row = document.createElement('div');
  row.className = 'row';

  const backBtn = document.createElement('a');
  backBtn.className = 'btn-mini primary';
  backBtn.href = practiceActiveGameUrl(active);
  backBtn.textContent = '回到当前牌局';
  row.appendChild(backBtn);

  const meBtn = document.createElement('a');
  meBtn.className = 'btn-mini ghost';
  meBtn.href = `${getBasePath()}me/#practice`;
  meBtn.textContent = '留在练习列表';
  row.appendChild(meBtn);

  body.appendChild(row);
  openModal('无法同时开始多个对局', '请先处理当前进行中的牌局。', body);
}

function channelLabel(ch: UserPayChannel): string {
  return ch === 'wechat_native' ? '微信扫码' : '支付宝';
}

function isMobileBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  const uaDataMobile = (navigator as any)?.userAgentData?.mobile;
  if (typeof uaDataMobile === 'boolean') {
    return uaDataMobile;
  }
  const ua = navigator.userAgent || '';
  if (/(Mobi|Android|iPhone|iPad|iPod|Windows Phone|Mobile)/i.test(ua)) {
    return true;
  }
  // iPadOS desktop UA fallback.
  if (navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1) {
    return true;
  }
  return false;
}

function isDesktopPayView(): boolean {
  return !isMobileBrowser();
}

function buildQrPath(modules: boolean[][], margin: number): string {
  const ops: Array<string> = [];
  for (let y = 0; y < modules.length; y++) {
    const row = modules[y] ?? [];
    let start: number | null = null;
    for (let x = 0; x <= row.length; x++) {
      const dark = x < row.length ? Boolean(row[x]) : false;
      if (dark && start === null) {
        start = x;
        continue;
      }
      if (!dark && start !== null) {
        ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
        start = null;
      }
    }
  }
  return ops.join('');
}

function buildQrImageUrl(data: string): string {
  const text = String(data ?? '').trim();
  if (!text) return '';
  const cached = payQrImageCache.get(text);
  if (cached) return cached;

  const qr = QrCode.encodeText(text, Ecc.MEDIUM);
  const modules = qr.getModules();
  const margin = 2;
  const gridSize = modules.length + margin * 2;
  const path = buildQrPath(modules, margin);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="320" viewBox="0 0 ${gridSize} ${gridSize}" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="#fff"/><path d="${path}" fill="#000"/></svg>`;
  const image = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  payQrImageCache.set(text, image);
  return image;
}

function shouldShowPayQrPanel(order: UserPayOrder | null): boolean {
  if (!order || !order.payUrl) return false;
  if (isDesktopPayView()) return true;
  return order.channel === 'wechat_native';
}

function renderPayQrPanel(order: UserPayOrder | null): void {
  if (!payQrPanelEl || !payQrTitleEl || !payQrImageEl || !payQrTipEl) return;
  if (!shouldShowPayQrPanel(order)) {
    payQrPanelEl.hidden = true;
    payQrImageEl.removeAttribute('src');
    payQrImageEl.removeAttribute('data-src');
    return;
  }
  if (!order || !order.payUrl) {
    payQrPanelEl.hidden = true;
    payQrImageEl.removeAttribute('src');
    payQrImageEl.removeAttribute('data-src');
    return;
  }

  const desktop = isDesktopPayView();
  let title = '';
  let tip = '';
  if (order.channel === 'alipay') {
    title = '请使用手机支付宝扫码支付';
    tip = `订单 ${order.id} · 支付宝 · ${order.amountYuanText} 元`;
  } else if (desktop) {
    title = '请使用手机微信扫码支付';
    tip = `订单 ${order.id} · 微信扫码 · ${order.amountYuanText} 元`;
  } else {
    title = '微信支付二维码';
    tip = `订单 ${order.id} · 微信 Native 在手机同机通常无法直接支付，请用另一台设备扫码。`;
  }
  payQrTitleEl.textContent = title;
  payQrTipEl.textContent = tip;
  payQrImageEl.src = buildQrImageUrl(order.payUrl);
  payQrImageEl.setAttribute('data-src', order.payUrl);
  payQrPanelEl.hidden = false;
}

function payStatusLabel(status: string): string {
  if (status === 'credited') return '已入账';
  if (status === 'paid') return '已支付，等待入账';
  if (status === 'expired') return '已过期';
  if (status === 'closed') return '已关闭';
  return '待支付';
}

function stopPayPolling(): void {
  if (payPollingTimer !== null) {
    window.clearInterval(payPollingTimer);
    payPollingTimer = null;
  }
}

function isFinalPayStatus(status: string): boolean {
  return status === 'credited' || status === 'expired' || status === 'closed';
}

modalClose.onclick = closeModal;
modal.onclick = (e) => {
  if (e.target === modal) closeModal();
};
window.addEventListener('resize', () => {
  renderPayQrPanel(payCurrentOrder);
});

function normalizePresetAvatarIndex(raw: unknown): number {
  const n = Number.isFinite(Number(raw)) ? Math.trunc(Number(raw)) : 0;
  return Math.max(0, Math.min(avatars.length - 1, n));
}

function resolveCustomAvatarUrl(user: UserPublic | null): string | null {
  const raw = typeof user?.avatarUrl === 'string' ? user.avatarUrl.trim() : '';
  if (!raw) return null;
  if (/^(?:https?:)?\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
    return raw;
  }
  if (raw.startsWith('/')) {
    const origin = resolveApiOrigin();
    if (origin) return `${origin}${raw}`;
  }
  return raw;
}

function hasCustomAvatar(user: UserPublic | null): boolean {
  return !!resolveCustomAvatarUrl(user);
}

function resolveApiOrigin(): string | null {
  if (apiOriginCache !== null) {
    return apiOriginCache || null;
  }
  try {
    const origin = new URL(getApiBaseUrl(), window.location.href).origin;
    apiOriginCache = origin || '';
    return origin || null;
  } catch {
    apiOriginCache = '';
    return null;
  }
}

function currentAvatarSrc(user: UserPublic | null): string {
  const custom = resolveCustomAvatarUrl(user);
  if (custom) return custom;
  const idx = normalizePresetAvatarIndex(user?.avatarIndex ?? selectedAvatarIndex);
  return avatars[idx] ?? avatars[0]!;
}

function renderAvatarCurrentCard(): void {
  const custom = hasCustomAvatar(currentUser);
  const presetIdx = normalizePresetAvatarIndex(selectedAvatarIndex);
  avatarCurrentImageEl.src = currentAvatarSrc(currentUser);
  avatarCurrentImageEl.alt = currentUser?.nickname ? `${currentUser.nickname} 的头像` : '当前头像';
  avatarCurrentTitleEl.textContent = custom ? '当前头像（自定义）' : `当前头像（预备 ${presetIdx + 1}）`;
  avatarCurrentDescEl.textContent = custom
    ? '你正在使用自定义头像。原图展示，不做自动裁剪。'
    : '你正在使用预备头像。可上传自定义头像进行替换。';
}

function renderAvatarSection(): void {
  renderAvatarCurrentCard();
}

function renderMatchPoints(): void {
  if (!matchPointsEl) return;
  if (!currentUser) {
    matchPointsEl.textContent = '-';
    return;
  }
  const points = Number.isFinite(currentUser.matchPoints) ? Math.max(0, Math.trunc(currentUser.matchPoints)) : 0;
  matchPointsEl.textContent = formatPoints(points);
}

function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const out = typeof reader.result === 'string' ? reader.result : '';
      if (!out) {
        reject(new Error('read failed'));
        return;
      }
      resolve(out);
    };
    reader.onerror = () => reject(new Error('read failed'));
    reader.readAsDataURL(file);
  });
}

async function uploadCustomAvatar(file: File): Promise<void> {
  const clearAvatarUploadInput = () => {
    avatarUploadInput.value = '';
  };
  if (!currentUser) {
    clearAvatarUploadInput();
    return;
  }
  const mime = String(file.type ?? '').toLowerCase();
  if (!mime || !['image/png', 'image/jpeg', 'image/webp', 'image/gif'].includes(mime)) {
    statusEl.textContent = '仅支持 PNG / JPG / WEBP / GIF 图片。';
    clearAvatarUploadInput();
    return;
  }
  if (file.size <= 0) {
    statusEl.textContent = '上传失败：图片为空。';
    clearAvatarUploadInput();
    return;
  }
  if (file.size > MAX_AVATAR_FILE_BYTES) {
    statusEl.textContent = '上传失败：图片不能超过 5MB。';
    clearAvatarUploadInput();
    return;
  }
  let dataUrl = '';
  try {
    dataUrl = await readFileAsDataUrl(file);
  } catch {
    statusEl.textContent = '上传失败：无法读取图片。';
    clearAvatarUploadInput();
    return;
  }

  setUiEnabled(false);
  statusEl.textContent = '正在上传头像…';
  try {
    const { user } = await uploadMeAvatar(dataUrl);
    currentUser = user;
    selectedAvatarIndex = normalizePresetAvatarIndex(user.avatarIndex);
    renderAvatarSection();
    renderMatchPoints();
    statusEl.textContent = '头像已更新。';
    window.setTimeout(() => setLoginStatusIfIdle('头像已更新。'), 900);
  } catch (err: unknown) {
    statusEl.textContent = `上传失败：${String((err as any)?.message ?? err)}`;
  } finally {
    clearAvatarUploadInput();
    setUiEnabled(true);
  }
}

function setUiEnabled(enabled: boolean): void {
  const busy = !enabled;
  uiBusy = busy;
  nickInput.disabled = busy;
  bgmEnabledInput.disabled = busy;
  sfxEnabledInput.disabled = busy;
  saveBtn.disabled = busy;
  avatarUploadBtn.disabled = busy;
  avatarUploadInput.disabled = busy;
  meTabAccountBtn.disabled = busy;
  meTabPayBtn.disabled = busy;
  meTabReplayBtn.disabled = busy;
  meTabPracticeBtn.disabled = busy;
  meTabSecurityBtn.disabled = busy;
  loginTokenVisibilityBtn.disabled = busy;
  copyLoginBtn.disabled = busy;
  resetLoginBtn.disabled = busy;
  resetApiBtn.disabled = busy;

  aiBillingRefreshBtn.disabled = busy;
  replayRefreshBtn.disabled = busy;
  replayFilterRoomAllBtn.disabled = busy;
  replayFilterRoomNewbieBtn.disabled = busy;
  replayFilterRoomFriendBtn.disabled = busy;
  replayFilterVariantAllBtn.disabled = busy;
  replayFilterVariantXuezhanBtn.disabled = busy;
  replayFilterVariantGuobiaoBtn.disabled = busy;
  replayFilterShareAllBtn.disabled = busy;
  replayFilterShareSharedBtn.disabled = busy;
  replayFilterShareUnsharedBtn.disabled = busy;
  practiceRefreshBtn.disabled = busy;
  payCreateOrderBtn.disabled = busy || !!payConfigError || payMode !== 'xorpay' || payPackages.length === 0;
  aiRulesTextarea.disabled = busy;
  aiRulesSaveBtn.disabled = busy;
  aiRulesResetBtn.disabled = busy || !aiRules.user;

  if (!busy) {
    // Re-apply logical disabled states computed from current data,
    // so we don't accidentally enable controls that should remain disabled.
    renderAiSettings();
    updateAiRulesDraftMeta();
    renderPaySection();
    renderReplayRecords();
    renderPracticeRecords();
  } else {
    const modelOptionButtons = aiOfficialModelOptionsEl.querySelectorAll('button');
    modelOptionButtons.forEach((b) => ((b as HTMLButtonElement).disabled = true));
    const payOptionButtons = mePanelPayEl.querySelectorAll('button[data-pay-option]');
    payOptionButtons.forEach((b) => ((b as HTMLButtonElement).disabled = true));
    const replayButtons = mePanelReplayEl.querySelectorAll('button');
    replayButtons.forEach((b) => ((b as HTMLButtonElement).disabled = true));
    const practiceButtons = mePanelPracticeEl.querySelectorAll('button');
    practiceButtons.forEach((b) => ((b as HTMLButtonElement).disabled = true));
  }
}

saveBtn.onclick = async () => {
  if (!currentUser) return;
  setUiEnabled(false);
  statusEl.textContent = '正在保存…';
  try {
    const nickname = nickInput.value.trim();
    const { user } = await updateMe({
      nickname,
      bgmEnabled: !!bgmEnabledInput.checked,
      sfxEnabled: !!sfxEnabledInput.checked,
    });
    currentUser = user;
    selectedAvatarIndex = normalizePresetAvatarIndex(user.avatarIndex);
    bgmEnabledInput.checked = user.bgmEnabled !== false;
    sfxEnabledInput.checked = user.sfxEnabled !== false;
    renderAvatarSection();
    renderMatchPoints();
    statusEl.textContent = '已保存。';
    setTimeout(() => {
      if (statusEl.textContent === '已保存。') statusEl.textContent = `已登录：${user.nickname}`;
    }, 1000);
  } catch (err: unknown) {
    statusEl.textContent = `保存失败：${String((err as any)?.message ?? err)}`;
  } finally {
    setUiEnabled(true);
  }
};

avatarUploadBtn.onclick = () => {
  if (uiBusy) return;
  avatarUploadInput.click();
};

avatarUploadInput.onchange = () => {
  const file = avatarUploadInput.files?.[0] ?? null;
  if (!file) {
    avatarUploadInput.value = '';
    return;
  }
  void uploadCustomAvatar(file);
};

bindSecretToggle(loginTokenInput, loginTokenVisibilityBtn, '登录口令');

copyLoginBtn.onclick = async () => {
  const token = loginTokenInput.value.trim();
  if (!token) return;
  await copyText(token);
  copyLoginBtn.textContent = '已复制';
  setTimeout(() => (copyLoginBtn.textContent = '复制'), 900);
};

resetApiBtn.onclick = async () => {
  if (!currentUser) return;
  if (!confirm('确定要重置令牌吗？旧令牌将立即失效。')) return;
  setUiEnabled(false);
  statusEl.textContent = '正在重置令牌…';
  try {
    const { apiToken, user } = await resetApiToken();
    currentUser = user;
    renderMatchPoints();
    statusEl.textContent = '已重置令牌（请立即复制保存）。';
    openModal('新的令牌', '该令牌仅展示一次，关闭后无法再次查看。', buildCopyField(apiToken, '令牌'));
  } catch (err: unknown) {
    statusEl.textContent = `重置失败：${String((err as any)?.message ?? err)}`;
  } finally {
    setUiEnabled(true);
  }
};

resetLoginBtn.onclick = async () => {
  if (!currentUser) return;
  if (!confirm('确定要重置登录口令吗？旧口令将立即失效。')) return;
  setUiEnabled(false);
  statusEl.textContent = '正在重置登录口令…';
  try {
    const { loginToken, user } = await resetLoginToken();
    setLoginToken(loginToken);
    currentUser = user;
    renderMatchPoints();
    loginTokenInput.value = loginToken;
    statusEl.textContent = '已重置登录口令（请立即复制保存）。';
    openModal('新的登录口令', '请立即复制保存。旧口令已失效。', buildCopyField(loginToken, '登录口令'));
  } catch (err: unknown) {
    statusEl.textContent = `重置失败：${String((err as any)?.message ?? err)}`;
  } finally {
    setUiEnabled(true);
  }
};

function buildCopyField(value: string, label?: string): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = 'field';
  if (label) {
    const t = document.createElement('div');
    t.className = 'sub';
    t.textContent = label;
    wrap.appendChild(t);
  }
  const input = document.createElement('input');
  input.readOnly = true;
  input.value = value;
  const inputWrap = document.createElement('div');
  inputWrap.className = 'secret-input-wrap';
  inputWrap.appendChild(input);
  inputWrap.appendChild(createSecretToggleButton(input, label ?? '口令'));
  const row = document.createElement('div');
  row.className = 'row';
  const copy = document.createElement('button');
  copy.type = 'button';
  copy.className = 'btn-mini ghost';
  copy.textContent = '复制';
  copy.onclick = async () => {
    await copyText(value);
    copy.textContent = '已复制';
    setTimeout(() => (copy.textContent = '复制'), 900);
  };
  row.appendChild(copy);
  wrap.appendChild(inputWrap);
  wrap.appendChild(row);
  return wrap;
}

function buildCopyTextField(value: string, label?: string): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = 'field';
  if (label) {
    const t = document.createElement('div');
    t.className = 'sub';
    t.textContent = label;
    wrap.appendChild(t);
  }
  const input = document.createElement('input');
  input.readOnly = true;
  input.value = value;
  wrap.appendChild(input);
  const row = document.createElement('div');
  row.className = 'row';
  const copy = document.createElement('button');
  copy.type = 'button';
  copy.className = 'btn-mini ghost';
  copy.textContent = '复制';
  copy.onclick = async () => {
    await copyText(value);
    copy.textContent = '已复制';
    setTimeout(() => (copy.textContent = '复制'), 900);
  };
  row.appendChild(copy);
  wrap.appendChild(row);
  return wrap;
}

async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    // fallback
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
  } finally {
    document.body.removeChild(ta);
  }
}

function renderOfficialModelOptions(): void {
  aiOfficialModelOptionsEl.innerHTML = '';
  const normalizedOptions =
    aiOfficialModelOptions.length > 0
      ? aiOfficialModelOptions
      : Array.from(new Set(aiOfficialModels.map((x) => String(x ?? '').trim()).filter(Boolean))).map((modelId) => ({
          gatewayId: String(aiOfficial.gatewayId ?? '').trim(),
          gatewayName: '',
          modelId,
          isSystemDefault: false,
        }));
  if (normalizedOptions.length === 0) {
    const empty = document.createElement('div');
    empty.className = 'sub';
    empty.textContent = '当前没有可选模型，请先在后台启用并验证模型。';
    aiOfficialModelOptionsEl.appendChild(empty);
    return;
  }

  const currentGatewayId = String(aiOfficial.gatewayId ?? '').trim();
  const currentModel = String(aiOfficial.model ?? '').trim();
  const modelIdCount = new Map<string, number>();
  for (const item of normalizedOptions) {
    modelIdCount.set(item.modelId, (modelIdCount.get(item.modelId) ?? 0) + 1);
  }
  const ordered = [...normalizedOptions].sort((a, b) => {
    if (a.isSystemDefault && !b.isSystemDefault) return -1;
    if (!a.isSystemDefault && b.isSystemDefault) return 1;
    if (a.modelId < b.modelId) return -1;
    if (a.modelId > b.modelId) return 1;
    if (a.gatewayName < b.gatewayName) return -1;
    if (a.gatewayName > b.gatewayName) return 1;
    return 0;
  });

  for (const item of ordered) {
    const modelId = item.modelId;
    const gatewayId = String(item.gatewayId ?? '').trim();
    const gatewayName = String(item.gatewayName ?? '').trim();
    const btn = document.createElement('button');
    btn.type = 'button';
    const sameGateway = !gatewayId || !currentGatewayId || gatewayId === currentGatewayId;
    const isCurrent = sameGateway && currentModel === modelId;
    btn.className = `ai-model-option${isCurrent ? ' is-selected' : ''}`;
    btn.disabled = uiBusy;
    btn.onclick = async () => {
      if (uiBusy) return;
      const sameModel = isCurrent;
      const usingOfficial = aiDefault.source === 'official';
      const overrideModel = String(aiOfficial.overrideModel ?? '').trim();
      const hasStaleOverride = !!overrideModel && !!currentModel && overrideModel !== currentModel;
      if (sameModel && usingOfficial && !hasStaleOverride) {
        statusEl.textContent = `当前已在使用 ${modelId}。`;
        return;
      }
      await applyOfficialModel(modelId, { switchToOfficialDefault: true, gatewayId: gatewayId || null });
    };

    const idEl = document.createElement('span');
    idEl.className = 'ai-model-id';
    const repeated = (modelIdCount.get(modelId) ?? 0) > 1;
    const modelLabel = repeated && gatewayName ? `${modelId} · ${gatewayName}` : modelId;
    idEl.textContent = isCurrent ? `${modelLabel}（在用）` : modelLabel;
    btn.appendChild(idEl);

    if (item.isSystemDefault) {
      const badge = document.createElement('span');
      badge.className = 'ai-model-default';
      badge.textContent = '系统默认';
      btn.appendChild(badge);
    }

    aiOfficialModelOptionsEl.appendChild(btn);
  }
}

function renderAiSettings(): void {
  const points = Number.isFinite(aiOfficial.points) ? Math.max(0, Math.trunc(aiOfficial.points)) : 0;
  aiOfficialHintEl.textContent = `大模型（荐牌点：${formatPoints(points)}）`;
  renderOfficialModelOptions();
}

async function loadAiSettings(): Promise<void> {
  const data = await fetchAiSettings();
  aiOfficialModelOptions = Array.isArray((data as any).officialModelOptions)
    ? ((data as any).officialModelOptions as Array<any>)
        .map((it) => ({
          gatewayId: String(it?.gatewayId ?? '').trim(),
          gatewayName: String(it?.gatewayName ?? '').trim(),
          modelId: String(it?.modelId ?? '').trim(),
          isSystemDefault: !!it?.isSystemDefault,
        }))
        .filter((it) => it.gatewayId && it.modelId)
    : [];
  aiOfficialModels =
    aiOfficialModelOptions.length > 0
      ? Array.from(new Set(aiOfficialModelOptions.map((it) => it.modelId)))
      : Array.isArray(data.models)
        ? data.models
        : [];
  aiDefault = data.default ?? { source: 'official', profileId: null };
  const official = data.official ?? aiOfficial;
  const rawPoints = typeof (official as any).points === 'number' ? (official as any).points : 0;
  const points = Number.isFinite(rawPoints) ? Math.trunc(rawPoints) : 0;
  aiOfficial = {
    ...aiOfficial,
    ...official,
    points,
  };
  aiSettingsLoaded = true;
  renderAiSettings();
}

function renderPaySection(): void {
  const hasPackages = payPackages.length > 0;
  const availableChannels = new Set(payChannels);
  if (!paySelectedPackageId || !payPackages.some((pkg) => pkg.id === paySelectedPackageId)) {
    paySelectedPackageId = payPackages[0]?.id ?? '';
  }
  if (!availableChannels.has(paySelectedChannel)) {
    if (availableChannels.has('alipay')) {
      paySelectedChannel = 'alipay';
    } else if (availableChannels.has('wechat_native')) {
      paySelectedChannel = 'wechat_native';
    } else {
      paySelectedChannel = 'alipay';
    }
  }

  if (payConfigError) {
    setPayModeTip(payConfigError);
  } else if (payMode !== 'xorpay') {
    setPayModeTip('当前为手动充值，请联系管理员。');
  } else if (!hasPackages) {
    setPayModeTip('已开启 XorPay，但暂未配置可售套餐。');
  } else if (payChannels.length === 0) {
    setPayModeTip('已开启 XorPay，但未配置可用支付渠道。');
  } else {
    setPayModeTip('');
  }

  const busy = uiBusy || !currentUser;
  const blocked = !!payConfigError || payMode !== 'xorpay' || !hasPackages;

  payPackageOptionsEl.innerHTML = '';
  if (!hasPackages) {
    const empty = document.createElement('div');
    empty.className = 'sub';
    empty.textContent = '暂无可选套餐';
    payPackageOptionsEl.appendChild(empty);
  } else {
    for (const pkg of payPackages) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `pay-option${pkg.id === paySelectedPackageId ? ' is-selected' : ''}`;
      btn.setAttribute('data-pay-option', '1');
      btn.disabled = busy || blocked;
      btn.onclick = () => {
        if (uiBusy || blocked) return;
        if (paySelectedPackageId === pkg.id) return;
        paySelectedPackageId = pkg.id;
        renderPaySection();
      };

      const title = document.createElement('div');
      title.className = 'pay-option-title';
      title.textContent = pkg.title;
      btn.appendChild(title);

      const price = Number.isFinite(pkg.priceCents) ? (Math.trunc(pkg.priceCents) / 100).toFixed(2) : '0.00';
      const points = formatPoints(pkg.points ?? 0);
      const meta = document.createElement('div');
      meta.className = 'pay-option-meta';
      meta.textContent = `${price} 元 · ${points} 点`;
      btn.appendChild(meta);

      payPackageOptionsEl.appendChild(btn);
    }
  }

  payChannelOptionsEl.innerHTML = '';
  if (payChannels.length === 0) {
    const empty = document.createElement('div');
    empty.className = 'sub';
    empty.textContent = '暂无可选支付方式';
    payChannelOptionsEl.appendChild(empty);
  } else {
    for (const ch of payChannels) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `pay-option${ch === paySelectedChannel ? ' is-selected' : ''}`;
      btn.setAttribute('data-pay-option', '1');
      btn.disabled = busy || blocked;
      btn.onclick = () => {
        if (uiBusy || blocked) return;
        if (paySelectedChannel === ch) return;
        paySelectedChannel = ch;
        renderPaySection();
      };

      const title = document.createElement('div');
      title.className = 'pay-option-title';
      title.textContent = channelLabel(ch);
      btn.appendChild(title);

      const meta = document.createElement('div');
      meta.className = 'pay-option-meta';
      meta.textContent = ch === 'alipay' ? '支付宝支付' : '微信支付';
      btn.appendChild(meta);

      payChannelOptionsEl.appendChild(btn);
    }
  }

  if (!payCurrentOrder) {
    payOrderStatusEl.textContent = payMode === 'xorpay' && !payConfigError ? '尚未创建订单' : '当前无订单';
    renderPayQrPanel(null);
  } else {
    const amount = Number.isFinite(payCurrentOrder.amountCents) ? (Math.trunc(payCurrentOrder.amountCents) / 100).toFixed(2) : '0.00';
    const points = formatPoints(payCurrentOrder.points ?? 0);
    payOrderStatusEl.textContent = `订单 ${payCurrentOrder.id} · ${channelLabel(payCurrentOrder.channel)} · ${amount} 元 / ${points} 点 · ${payStatusLabel(
      payCurrentOrder.status,
    )}`;
    renderPayQrPanel(payCurrentOrder);
  }

  payCreateOrderBtn.disabled = busy || blocked || !paySelectedPackageId || !availableChannels.has(paySelectedChannel);
  scheduleMeCanvasScale();
}

async function refreshPayOrder(orderId: string): Promise<void> {
  const out = await fetchPayOrder(orderId);
  payCurrentOrder = out.order ?? null;
  renderPaySection();
}

function startPayPolling(orderId: string): void {
  stopPayPolling();
  let attempts = 0;
  payPollingTimer = window.setInterval(async () => {
    attempts += 1;
    try {
      await refreshPayOrder(orderId);
      if (!payCurrentOrder || payCurrentOrder.id !== orderId) {
        stopPayPolling();
        return;
      }
      if (isFinalPayStatus(payCurrentOrder.status)) {
        stopPayPolling();
        if (payCurrentOrder.status === 'credited') {
          try {
            await loadAiBilling();
          } catch {
            // ignore: user can still refresh billing manually
          }
        }
      }
    } catch {
      if (attempts >= 40) {
        stopPayPolling();
      }
    }
  }, 3000);
}

async function loadPayConfig(): Promise<void> {
  const out = await fetchPayConfig();
  payConfigError = null;
  payMode = out.paymentMode === 'xorpay' ? 'xorpay' : 'manual';
  payPackages = Array.isArray(out.packages)
    ? out.packages
        .map((x) => ({
          id: String(x.id ?? '').trim(),
          title: String(x.title ?? '').trim(),
          priceCents: Math.max(0, Math.trunc(Number(x.priceCents) || 0)),
          priceCny: Number(x.priceCny ?? 0),
          points: Math.max(0, Math.trunc(Number(x.points) || 0)),
          enabled: !!x.enabled,
          sort: Math.trunc(Number(x.sort) || 0),
        }))
        .filter((x) => x.id && x.title && x.priceCents > 0 && x.points > 0)
    : [];
  payChannels = Array.isArray(out.channels)
    ? out.channels.filter((x) => x === 'alipay' || x === 'wechat_native')
    : ['alipay', 'wechat_native'];
  if (payChannels.length === 0) {
    payChannels = ['alipay', 'wechat_native'];
  }

  if (payCurrentOrder && isFinalPayStatus(payCurrentOrder.status)) {
    stopPayPolling();
  }
  payConfigLoaded = true;
  renderPaySection();
  if (aiSettingsLoaded) {
    renderAiSettings();
  }
}

function renderAiBilling(): void {
  aiBillingPointsEl.textContent = formatPoints(aiOfficial.points ?? 0);
  aiBillingListEl.innerHTML = '';
  if (aiBillingItems.length === 0) {
    const empty = document.createElement('div');
    empty.className = 'ai-item';
    empty.textContent = '暂无记录';
    aiBillingListEl.appendChild(empty);
    scheduleMeCanvasScale();
    return;
  }

  const grouped = [
    { kind: 'recharge' as const, title: '充值入账', items: aiBillingItems.filter((it) => it.kind === 'recharge') },
    { kind: 'ai_charge' as const, title: '', items: aiBillingItems.filter((it) => it.kind === 'ai_charge') },
    { kind: 'admin_adjust' as const, title: '后台调整', items: aiBillingItems.filter((it) => it.kind === 'admin_adjust') },
  ].filter((g) => g.items.length > 0);

  for (const group of grouped) {
    const wrap = document.createElement('div');
    wrap.className = 'ai-group';

    if (group.title) {
      const groupTitle = document.createElement('div');
      groupTitle.className = 'ai-group-title';
      groupTitle.textContent = group.title;
      wrap.appendChild(groupTitle);
    }

    for (const it of group.items) {
      const item = document.createElement('div');
      item.className = 'ai-item';

      const head = document.createElement('div');
      head.className = 'ai-item-head';
      const title = document.createElement('div');
      title.className = 'ai-alias';
      title.textContent = group.title ? `${formatTime(it.createdAt)} · ${group.title}` : formatTime(it.createdAt);
      head.appendChild(title);
      item.appendChild(head);

      const delta = Math.trunc(it.changePoints ?? 0);
      const deltaAbs = Math.abs(delta);
      const sign = delta >= 0 ? '+' : '-';
      const detail = document.createElement('div');
      detail.className = 'ai-meta';
      if (group.kind === 'ai_charge') {
        detail.textContent = `模型 ${it.modelId ?? '-'} · input ${it.usageInputTokens ?? 0} · output ${it.usageOutputTokens ?? 0} · 扣 ${deltaAbs} 点${
          it.fallbackCharged ? '（保底）' : ''
        }`;
      } else if (group.kind === 'recharge') {
        detail.textContent = `充值 ${sign}${deltaAbs} 点 · 渠道备注 ${it.note ?? '-'}`;
      } else {
        detail.textContent = `变更 ${sign}${deltaAbs} 点`;
      }
      item.appendChild(detail);

      if (group.kind === 'ai_charge') {
        const req = document.createElement('div');
        req.className = 'ai-meta';
        req.textContent = `请求ID ${it.requestId ?? '-'} · 场景 ${it.scene ?? '-'} · 价格版本 ${it.priceVersion ?? '-'}`;
        item.appendChild(req);
      } else if (group.kind === 'recharge') {
        const req = document.createElement('div');
        req.className = 'ai-meta';
        req.textContent = `订单号 ${it.requestId ?? '-'} · 场景 ${it.scene ?? '-'}`;
        item.appendChild(req);
      }

      const bal = document.createElement('div');
      bal.className = 'ai-meta';
      bal.textContent = `余额 ${formatPoints(it.balanceBefore ?? 0)} → ${formatPoints(it.balanceAfter ?? 0)}`;
      item.appendChild(bal);

      if (it.note && group.kind !== 'recharge') {
        const note = document.createElement('div');
        note.className = 'ai-meta';
        note.textContent = `备注：${it.note}`;
        item.appendChild(note);
      }

      wrap.appendChild(item);
    }

    aiBillingListEl.appendChild(wrap);
  }
  scheduleMeCanvasScale();
}

async function loadAiBilling(): Promise<void> {
  const data = await fetchAiBilling({ limit: 50, offset: 0 });
  aiOfficial.points = Number.isFinite(data.officialPoints) ? Math.trunc(data.officialPoints) : aiOfficial.points;
  aiBillingItems = Array.isArray(data.items) ? data.items : [];
  aiBillingLoaded = true;
  renderAiSettings();
  renderAiBilling();
}

async function loadAiRules(): Promise<void> {
  const data = await fetchAiRules();
  aiRules = { source: data.source, global: data.global ?? '', user: data.user ?? null };
  aiRulesLoaded = true;
  aiRulesSourceEl.textContent = data.source === 'user' ? '自定义（优先）' : '全局';
  aiRulesTextarea.value = aiRules.user ?? aiRules.global;
  aiRulesSavedText = aiRulesTextarea.value;
  updateAiRulesDraftMeta();
}

async function ensurePayTabLoaded(): Promise<void> {
  if (payConfigLoaded && aiBillingLoaded) return;
  if (payTabLoadPromise) {
    await payTabLoadPromise;
    return;
  }
  payTabLoadPromise = (async () => {
    const loadingText = '正在加载充值信息…';
    const shouldToggleBusy = !uiBusy;
    if (shouldToggleBusy) {
      setUiEnabled(false);
      statusEl.textContent = loadingText;
    }
    try {
      if (!payConfigLoaded) {
        try {
          await loadPayConfig();
        } catch (err: unknown) {
          payConfigError = `加载支付配置失败：${String((err as any)?.message ?? err)}`;
          renderPaySection();
        }
      }
      if (!aiBillingLoaded) {
        try {
          await loadAiBilling();
        } catch {
          renderAiBilling();
        }
      }
      setLoginStatusIfIdle(loadingText);
    } finally {
      if (shouldToggleBusy) {
        setUiEnabled(true);
      }
    }
  })();
  try {
    await payTabLoadPromise;
  } finally {
    payTabLoadPromise = null;
  }
}

function openPracticeShareModal(url: string): void {
  openModal('分享练习题', '登录后即可直接进入；若已有未完成练习局，则优先继续。', buildCopyTextField(url, '分享链接'));
}

function openPaipuShareModal(url: string): void {
  openModal('分享牌谱', '分享链接长期有效；登录后即可查看严格本人视角牌谱。', buildCopyTextField(url, '分享链接'));
}

function applyReplayFiltersToButtons(): void {
  const roomButtons: Array<{ btn: HTMLButtonElement; on: boolean }> = [
    { btn: replayFilterRoomAllBtn, on: replayRoomFilter === 'all' },
    { btn: replayFilterRoomNewbieBtn, on: replayRoomFilter === 'newbie' },
    { btn: replayFilterRoomFriendBtn, on: replayRoomFilter === 'friend' },
  ];
  for (const item of roomButtons) {
    item.btn.classList.toggle('filter-on', item.on);
  }
  const variantButtons: Array<{ btn: HTMLButtonElement; on: boolean }> = [
    { btn: replayFilterVariantAllBtn, on: replayVariantFilter === 'all' },
    { btn: replayFilterVariantXuezhanBtn, on: replayVariantFilter === 'xuezhan' },
    { btn: replayFilterVariantGuobiaoBtn, on: replayVariantFilter === 'guobiao' },
  ];
  for (const item of variantButtons) {
    item.btn.classList.toggle('filter-on', item.on);
  }
  const shareButtons: Array<{ btn: HTMLButtonElement; on: boolean }> = [
    { btn: replayFilterShareAllBtn, on: replayShareFilter === 'all' },
    { btn: replayFilterShareSharedBtn, on: replayShareFilter === 'shared' },
    { btn: replayFilterShareUnsharedBtn, on: replayShareFilter === 'unshared' },
  ];
  for (const item of shareButtons) {
    item.btn.classList.toggle('filter-on', item.on);
  }
}

function replayShareLabel(item: PaipuListItem): string {
  return item.share.shared ? '已分享' : '未分享';
}

function openPaipuDetail(gameId: string): void {
  const basePath = getBasePath();
  window.location.href = `${basePath}hand/?mode=paipu&gameId=${encodeURIComponent(gameId)}`;
}

function replaceReplayShareState(gameId: string, shareId: string, createdAt: number, sharePath: string): void {
  replayRecords = replayRecords.map((item) => {
    if (item.gameId !== gameId) return item;
    return {
      ...item,
      share: {
        shared: true,
        shareId,
        shareCreatedAt: createdAt,
        sharePath,
      },
    };
  }).filter((item) => {
    if (replayShareFilter === 'shared') return item.share.shared;
    if (replayShareFilter === 'unshared') return !item.share.shared;
    return true;
  });
}

function removeReplayRecord(gameId: string): void {
  replayRecords = replayRecords.filter((item) => item.gameId !== gameId);
}

function renderReplayRecords(): void {
  applyReplayFiltersToButtons();
  if (!replayRecordsLoaded) {
    replayListEl.innerHTML = '<div class="practice-empty">首次进入时加载牌谱。</div>';
    scheduleMeCanvasScale();
    return;
  }

  replayListEl.innerHTML = '';
  const group = document.createElement('section');
  group.className = 'practice-group';

  const head = document.createElement('div');
  head.className = 'practice-group-head';
  group.appendChild(head);

  const titleWrap = document.createElement('div');
  titleWrap.className = 'practice-group-title-wrap';
  head.appendChild(titleWrap);

  const title = document.createElement('div');
  title.className = 'practice-group-title';
  title.textContent = '我的牌谱（每局结束后自动沉淀；点击可进入严格本人视角回放。）';
  titleWrap.appendChild(title);

  const count = document.createElement('div');
  count.className = 'practice-group-count';
  count.textContent = String(replayRecords.length);
  head.appendChild(count);

  if (replayRecords.length <= 0) {
    const empty = document.createElement('div');
    empty.className = 'practice-empty';
    empty.textContent = '还没有可查看的牌谱。';
    group.appendChild(empty);
    replayListEl.appendChild(group);
    scheduleMeCanvasScale();
    return;
  }

  for (const item of replayRecords) {
    const card = document.createElement('div');
    card.className = 'practice-item';

    const cardHead = document.createElement('div');
    cardHead.className = 'practice-head';
    card.appendChild(cardHead);

    const cardTitle = document.createElement('div');
    cardTitle.className = 'practice-title';
    cardTitle.textContent = `${paipuVariantLabel(item.rules?.variant)} · ${paipuRoomLabel(item.roomType)} · ${formatTime(item.finishedAt)}`;
    cardHead.appendChild(cardTitle);

    const headSide = document.createElement('div');
    headSide.className = 'replay-card-head-side';
    cardHead.appendChild(headSide);

    const tags = document.createElement('div');
    tags.className = 'practice-tags replay-card-head-tags';
    headSide.appendChild(tags);

    const roomTag = document.createElement('div');
    roomTag.className = 'practice-tag';
    roomTag.textContent = paipuRoomLabel(item.roomType);
    tags.appendChild(roomTag);

    const variantTag = document.createElement('div');
    variantTag.className = 'practice-tag';
    variantTag.textContent = paipuVariantLabel(item.rules?.variant);
    tags.appendChild(variantTag);

    const shareTag = document.createElement('div');
    shareTag.className = 'practice-tag';
    shareTag.textContent = replayShareLabel(item);
    tags.appendChild(shareTag);

    const status = document.createElement('div');
    status.className = 'practice-status';
    status.textContent = item.myResult.rank ? `第 ${item.myResult.rank} 名` : '已结束';
    headSide.appendChild(status);

    const summary = document.createElement('div');
    summary.className = 'replay-card-summary';
    card.appendChild(summary);

    const meta = document.createElement('div');
    meta.className = 'practice-meta replay-card-summary-main';
    meta.textContent = [
      `房间：${paipuRoomLabel(item.roomType)}`,
      `座位：${item.mySeat + 1}号位`,
      paipuResultLabel(item),
    ].join(' · ');
    summary.appendChild(meta);

    const note = document.createElement('div');
    note.className = 'practice-note replay-card-summary-side replay-players-line';
    const playersLabel = document.createElement('span');
    playersLabel.className = 'replay-players-label';
    playersLabel.textContent = '参与玩家：';
    note.appendChild(playersLabel);
    const playersList = document.createElement('div');
    playersList.className = 'replay-players-list';
    for (const player of item.players) {
      const name = player.nickname || `玩家${player.seat + 1}`;
      const chip = document.createElement('span');
      chip.className = 'replay-player-name';
      chip.textContent = name;
      chip.title = name;
      playersList.appendChild(chip);
    }
    note.appendChild(playersList);
    summary.appendChild(note);

    const actions = document.createElement('div');
    actions.className = 'practice-actions';
    card.appendChild(actions);

    const openBtn = document.createElement('button');
    openBtn.type = 'button';
    openBtn.className = 'btn-mini primary';
    openBtn.textContent = '查看牌谱';
    openBtn.disabled = uiBusy;
    openBtn.onclick = () => {
      if (uiBusy) return;
      openPaipuDetail(item.gameId);
    };
    actions.appendChild(openBtn);

    const shareBtn = document.createElement('button');
    shareBtn.type = 'button';
    shareBtn.className = 'btn-mini ghost';
    shareBtn.textContent = item.share.shared ? '复制分享' : '分享';
    shareBtn.disabled = uiBusy;
    shareBtn.onclick = async () => {
      if (uiBusy) return;
      setUiEnabled(false);
      statusEl.textContent = '正在准备牌谱分享链接…';
      try {
        const out = await createPaipuShare(item.gameId);
        replaceReplayShareState(item.gameId, out.shareId, out.createdAt, out.sharePath);
        renderReplayRecords();
        const shareUrl = buildAppUrl(out.sharePath);
        await copyText(shareUrl);
        openPaipuShareModal(shareUrl);
        statusEl.textContent = out.created ? '牌谱分享链接已创建并复制。' : '牌谱分享链接已复制。';
      } catch (err: unknown) {
        statusEl.textContent = `分享失败：${String((err as any)?.message ?? err)}`;
      } finally {
        setUiEnabled(true);
      }
    };
    actions.appendChild(shareBtn);

    const deleteBtn = document.createElement('button');
    deleteBtn.type = 'button';
    deleteBtn.className = 'btn-mini danger';
    deleteBtn.textContent = '删除';
    deleteBtn.disabled = uiBusy;
    deleteBtn.onclick = async () => {
      if (uiBusy) return;
      if (!confirm('确定删除这局牌谱吗？删除后仅对你自己隐藏，且你生成过的分享链接会失效。')) return;
      setUiEnabled(false);
      statusEl.textContent = '正在删除牌谱…';
      try {
        await deletePaipu(item.gameId);
        removeReplayRecord(item.gameId);
        renderReplayRecords();
        statusEl.textContent = '牌谱已删除。';
      } catch (err: unknown) {
        statusEl.textContent = `删除失败：${String((err as any)?.message ?? err)}`;
      } finally {
        setUiEnabled(true);
      }
    };
    actions.appendChild(deleteBtn);

    group.appendChild(card);
  }

  replayListEl.appendChild(group);
  scheduleMeCanvasScale();
}

async function loadReplayRecords(): Promise<void> {
  const out = await listMyPaipus({
    roomType: replayRoomFilter === 'all' ? null : replayRoomFilter,
    variant: replayVariantFilter === 'all' ? null : replayVariantFilter,
    shared: replayShareFilter === 'all' ? null : replayShareFilter,
  });
  replayRecords = Array.isArray(out?.items) ? out.items : [];
  replayRecordsLoaded = true;
  renderReplayRecords();
}

async function ensureReplayTabLoaded(): Promise<void> {
  if (replayRecordsLoaded) return;
  if (replayTabLoadPromise) {
    await replayTabLoadPromise;
    return;
  }
  replayTabLoadPromise = (async () => {
    const loadingText = '正在加载牌谱…';
    const shouldToggleBusy = !uiBusy;
    if (shouldToggleBusy) {
      setUiEnabled(false);
      statusEl.textContent = loadingText;
    }
    try {
      await loadReplayRecords();
      setLoginStatusIfIdle(loadingText);
    } finally {
      if (shouldToggleBusy) {
        setUiEnabled(true);
      }
    }
  })();
  try {
    await replayTabLoadPromise;
  } finally {
    replayTabLoadPromise = null;
  }
}

function openPracticeRecordEditor(item: PracticeRecordSummary): void {
  const body = document.createElement('div');
  body.className = 'field';

  const titleField = document.createElement('div');
  titleField.className = 'field';
  const titleLabel = document.createElement('label');
  titleLabel.textContent = '标题';
  const titleInput = document.createElement('input');
  titleInput.type = 'text';
  titleInput.maxLength = 80;
  titleInput.value = String(item.title ?? '');
  titleField.appendChild(titleLabel);
  titleField.appendChild(titleInput);
  body.appendChild(titleField);

  const noteField = document.createElement('div');
  noteField.className = 'field';
  const noteLabel = document.createElement('label');
  noteLabel.textContent = '备注';
  const noteInput = document.createElement('textarea');
  noteInput.maxLength = 500;
  noteInput.value = String(item.note ?? '');
  noteField.appendChild(noteLabel);
  noteField.appendChild(noteInput);
  body.appendChild(noteField);

  const row = document.createElement('div');
  row.className = 'row';
  const saveBtnEl = document.createElement('button');
  saveBtnEl.type = 'button';
  saveBtnEl.className = 'btn-mini primary';
  saveBtnEl.textContent = '保存';
  const cancelBtnEl = document.createElement('button');
  cancelBtnEl.type = 'button';
  cancelBtnEl.className = 'btn-mini ghost';
  cancelBtnEl.textContent = '取消';
  cancelBtnEl.onclick = closeModal;
  row.appendChild(saveBtnEl);
  row.appendChild(cancelBtnEl);
  body.appendChild(row);

  saveBtnEl.onclick = async () => {
    if (uiBusy) return;
    setUiEnabled(false);
    statusEl.textContent = '正在保存练习记录…';
    try {
      const out = await patchPracticeRecord(item.recordId, {
        title: titleInput.value.trim() || null,
        note: noteInput.value.trim() || null,
      });
      replacePracticeRecord(out.record);
      renderPracticeRecords();
      closeModal();
      statusEl.textContent = '练习记录已保存。';
    } catch (err: unknown) {
      statusEl.textContent = `保存失败：${String((err as any)?.message ?? err)}`;
    } finally {
      setUiEnabled(true);
    }
  };

  openModal('编辑练习题', '标题与备注仅影响你自己的记录；若你分享这道题，分享文案会同步更新。', body);
}

function renderPracticeSection(params: {
  title: string;
  subtitle: string;
  items: Array<PracticeRecordSummary>;
  emptyText: string;
}): HTMLElement {
  const section = document.createElement('section');
  section.className = 'practice-group';

  const head = document.createElement('div');
  head.className = 'practice-group-head';
  section.appendChild(head);

  const titleWrap = document.createElement('div');
  titleWrap.className = 'practice-group-title-wrap';
  head.appendChild(titleWrap);

  const title = document.createElement('div');
  title.className = 'practice-group-title';
  title.textContent = params.title;
  titleWrap.appendChild(title);

  if (params.subtitle.trim()) {
    const subtitle = document.createElement('div');
    subtitle.className = 'practice-group-sub';
    subtitle.textContent = params.subtitle;
    titleWrap.appendChild(subtitle);
  }

  const count = document.createElement('div');
  count.className = 'practice-group-count';
  count.textContent = String(params.items.length);
  head.appendChild(count);

  if (params.items.length <= 0) {
    const empty = document.createElement('div');
    empty.className = 'practice-empty';
    empty.textContent = params.emptyText;
    section.appendChild(empty);
    return section;
  }

  const list = document.createElement('div');
  list.className = 'practice-list';
  section.appendChild(list);

  for (const item of params.items) {
    const card = document.createElement('div');
    card.className = 'practice-item';

    const head = document.createElement('div');
    head.className = 'practice-head';
    card.appendChild(head);

    const title = document.createElement('div');
    title.className = 'practice-title';
    title.textContent = (item.title ?? '').trim() || practiceSceneLabel(item.scene);
    head.appendChild(title);

    const headSide = document.createElement('div');
    headSide.className = 'replay-card-head-side';
    head.appendChild(headSide);

    const shareTag = document.createElement('div');
    shareTag.className = 'practice-tag';
    shareTag.textContent = practiceShareStateLabel(item.shareState);
    headSide.appendChild(shareTag);

    const status = document.createElement('div');
    status.className = 'practice-status';
    status.textContent = practiceStatusLabel(item);
    headSide.appendChild(status);

    const meta = document.createElement('div');
    meta.className = 'practice-meta';
    meta.textContent = [
      `来源：${practiceRoomLabel(item.sourceRoomType)} ${item.sourceGameId}`,
      `类型：${practiceSceneLabel(item.scene)}`,
      `创建：${formatTime(item.createdAt)}`,
    ].join(' · ');
    card.appendChild(meta);

    if (item.templateStatus === 'disabled') {
      const tags = document.createElement('div');
      tags.className = 'practice-tags';
      const invalidTag = document.createElement('div');
      invalidTag.className = 'practice-tag danger';
      invalidTag.textContent = '已失效';
      tags.appendChild(invalidTag);
      card.appendChild(tags);
    }

    if ((item.note ?? '').trim()) {
      const note = document.createElement('div');
      note.className = 'practice-note';
      note.textContent = String(item.note ?? '').trim();
      card.appendChild(note);
    }

    const actions = document.createElement('div');
    actions.className = 'practice-actions';
    card.appendChild(actions);

    const enterBtn = document.createElement('button');
    enterBtn.type = 'button';
    enterBtn.className = 'btn-mini primary';
    enterBtn.textContent = practiceEnterLabel(item);
    enterBtn.disabled = uiBusy || !practiceCanEnter(item);
    enterBtn.onclick = async () => {
      if (uiBusy) return;
      setUiEnabled(false);
      statusEl.textContent = '正在进入练习题…';
      try {
        const out = await enterPracticeRecord(item.recordId);
        const basePath = getBasePath();
        window.location.href = `${basePath}hand/?gameId=${encodeURIComponent(out.gameId)}`;
      } catch (err: unknown) {
        const active = normalizeActiveGame((err as any)?.data?.activeGame);
        if (active) {
          statusEl.textContent = '当前已有进行中的牌局。';
          openPracticeActiveGameModal(active);
        } else {
          statusEl.textContent = `进入失败：${String((err as any)?.message ?? err)}`;
        }
      } finally {
        setUiEnabled(true);
      }
    };
    actions.appendChild(enterBtn);

    const shareBtn = document.createElement('button');
    shareBtn.type = 'button';
    shareBtn.className = 'btn-mini ghost';
    shareBtn.textContent = item.shareState === 'shared' ? '复制分享' : '分享';
    shareBtn.disabled = uiBusy || !practiceCanShare(item);
    shareBtn.onclick = async () => {
      if (uiBusy) return;
      setUiEnabled(false);
      statusEl.textContent = '正在准备分享链接…';
      try {
        const out = await sharePracticeRecord(item.recordId);
        replacePracticeRecord(out.record);
        renderPracticeRecords();
        openPracticeShareModal(buildAppUrl(out.sharePath));
        statusEl.textContent = '分享链接已就绪。';
      } catch (err: unknown) {
        statusEl.textContent = `分享失败：${String((err as any)?.message ?? err)}`;
      } finally {
        setUiEnabled(true);
      }
    };
    actions.appendChild(shareBtn);

    const editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'btn-mini ghost';
    editBtn.textContent = '编辑';
    editBtn.disabled = uiBusy;
    editBtn.onclick = () => openPracticeRecordEditor(item);
    actions.appendChild(editBtn);

    const deleteBtn = document.createElement('button');
    deleteBtn.type = 'button';
    deleteBtn.className = 'btn-mini danger';
    deleteBtn.textContent = '删除';
    deleteBtn.disabled = uiBusy;
    deleteBtn.onclick = async () => {
      if (uiBusy) return;
      setUiEnabled(false);
      statusEl.textContent = '正在删除练习记录…';
      try {
        await deletePracticeRecord(item.recordId);
        removePracticeRecord(item.recordId);
        renderPracticeRecords();
        statusEl.textContent = '练习记录已删除。';
      } catch (err: unknown) {
        statusEl.textContent = `删除失败：${String((err as any)?.message ?? err)}`;
      } finally {
        setUiEnabled(true);
      }
    };
    actions.appendChild(deleteBtn);

    list.appendChild(card);
  }

  return section;
}

function renderPracticeRecords(): void {
  if (!practiceRecordsLoaded) {
    practiceListEl.innerHTML = '<div class="practice-empty">首次进入时加载练习题。</div>';
    scheduleMeCanvasScale();
    return;
  }
  practiceListEl.innerHTML = '';
  practiceListEl.appendChild(
    renderPracticeSection({
      title: '我的练习分支（从原牌局创建的个人练习记录；分享后仍保留在这里。）',
      subtitle: '',
      items: practiceRecordsMine,
      emptyText: '还没有自己的练习分支。',
    }),
  );
  practiceListEl.appendChild(
    renderPracticeSection({
      title: '共享练习题（通过分享链接收藏的题目；若有未完成练习局，将优先继续。）',
      subtitle: '',
      items: practiceRecordsShared,
      emptyText: '还没有收藏共享练习题。',
    }),
  );
  scheduleMeCanvasScale();
}

async function loadPracticeRecords(): Promise<void> {
  const out = await listPracticeRecords();
  practiceRecordsMine = Array.isArray(out?.mine) ? out.mine : [];
  practiceRecordsShared = Array.isArray(out?.shared) ? out.shared : [];
  practiceRecordsLoaded = true;
  renderPracticeRecords();
}

async function ensurePracticeTabLoaded(): Promise<void> {
  if (practiceRecordsLoaded) return;
  if (practiceTabLoadPromise) {
    await practiceTabLoadPromise;
    return;
  }
  practiceTabLoadPromise = (async () => {
    const loadingText = '正在加载练习题…';
    const shouldToggleBusy = !uiBusy;
    if (shouldToggleBusy) {
      setUiEnabled(false);
      statusEl.textContent = loadingText;
    }
    try {
      await loadPracticeRecords();
      setLoginStatusIfIdle(loadingText);
    } finally {
      if (shouldToggleBusy) {
        setUiEnabled(true);
      }
    }
  })();
  try {
    await practiceTabLoadPromise;
  } finally {
    practiceTabLoadPromise = null;
  }
}

async function ensureSecurityTabLoaded(): Promise<void> {
  if (aiSettingsLoaded && aiRulesLoaded) return;
  if (securityTabLoadPromise) {
    await securityTabLoadPromise;
    return;
  }
  securityTabLoadPromise = (async () => {
    const loadingText = '正在加载登录与大模型信息…';
    const shouldToggleBusy = !uiBusy;
    if (shouldToggleBusy) {
      setUiEnabled(false);
      statusEl.textContent = loadingText;
    }
    try {
      if (!aiSettingsLoaded) {
        try {
          await loadAiSettings();
        } catch (err: unknown) {
          statusEl.textContent = `加载失败：${String((err as any)?.message ?? err)}`;
        }
      }
      if (!aiRulesLoaded) {
        try {
          await loadAiRules();
        } catch {
          aiRulesSourceEl.textContent = '加载失败';
        }
      }
      setLoginStatusIfIdle(loadingText);
    } finally {
      if (shouldToggleBusy) {
        setUiEnabled(true);
      }
    }
  })();
  try {
    await securityTabLoadPromise;
  } finally {
    securityTabLoadPromise = null;
  }
}

async function switchMeTab(tab: MeTab, opts?: { syncHash?: boolean }): Promise<void> {
  activeTab = tab;
  renderMeTabs(tab);
  if (opts?.syncHash !== false) {
    const hash = tabHash(tab);
    if (window.location.hash !== hash) {
      window.history.replaceState(null, '', hash);
    }
  }
  if (tab === 'pay') {
    await ensurePayTabLoaded();
    scheduleMeCanvasScale();
    return;
  }
  if (tab === 'replay') {
    await ensureReplayTabLoaded();
    scheduleMeCanvasScale();
    return;
  }
  if (tab === 'practice') {
    await ensurePracticeTabLoaded();
    scheduleMeCanvasScale();
    return;
  }
  if (tab === 'security') {
    await ensureSecurityTabLoaded();
  }
  scheduleMeCanvasScale();
}

function initializeTabs(): void {
  if (tabsInitialized) return;
  tabsInitialized = true;
  meTabAccountBtn.onclick = () => {
    void switchMeTab('account');
  };
  meTabPayBtn.onclick = () => {
    void switchMeTab('pay');
  };
  meTabReplayBtn.onclick = () => {
    void switchMeTab('replay');
  };
  meTabPracticeBtn.onclick = () => {
    void switchMeTab('practice');
  };
  meTabSecurityBtn.onclick = () => {
    void switchMeTab('security');
  };
  window.addEventListener('hashchange', () => {
    const tab = parseMeTabFromHash();
    if (tab !== activeTab) {
      void switchMeTab(tab, { syncHash: false });
    }
  });
  renderMeTabs(activeTab);
}

practiceRefreshBtn.onclick = async () => {
  setUiEnabled(false);
  statusEl.textContent = '正在刷新练习题…';
  try {
    await loadPracticeRecords();
    statusEl.textContent = '练习题已刷新。';
  } catch (err: unknown) {
    statusEl.textContent = `刷新失败：${String((err as any)?.message ?? err)}`;
  } finally {
    setUiEnabled(true);
  }
};

replayRefreshBtn.onclick = async () => {
  setUiEnabled(false);
  statusEl.textContent = '正在刷新牌谱…';
  try {
    await loadReplayRecords();
    statusEl.textContent = '牌谱已刷新。';
  } catch (err: unknown) {
    statusEl.textContent = `刷新失败：${String((err as any)?.message ?? err)}`;
  } finally {
    setUiEnabled(true);
  }
};

async function applyReplayFilters(params: {
  room?: 'all' | 'newbie' | 'friend';
  variant?: 'all' | 'xuezhan' | 'guobiao';
  shared?: 'all' | 'shared' | 'unshared';
}): Promise<void> {
  if (params.room) replayRoomFilter = params.room;
  if (params.variant) replayVariantFilter = params.variant;
  if (params.shared) replayShareFilter = params.shared;
  replayRecordsLoaded = false;
  renderReplayRecords();
  setUiEnabled(false);
  statusEl.textContent = '正在筛选牌谱…';
  try {
    await loadReplayRecords();
    statusEl.textContent = '牌谱筛选已更新。';
  } catch (err: unknown) {
    statusEl.textContent = `筛选失败：${String((err as any)?.message ?? err)}`;
  } finally {
    setUiEnabled(true);
  }
}

replayFilterRoomAllBtn.onclick = () => void applyReplayFilters({ room: 'all' });
replayFilterRoomNewbieBtn.onclick = () => void applyReplayFilters({ room: 'newbie' });
replayFilterRoomFriendBtn.onclick = () => void applyReplayFilters({ room: 'friend' });
replayFilterVariantAllBtn.onclick = () => void applyReplayFilters({ variant: 'all' });
replayFilterVariantXuezhanBtn.onclick = () => void applyReplayFilters({ variant: 'xuezhan' });
replayFilterVariantGuobiaoBtn.onclick = () => void applyReplayFilters({ variant: 'guobiao' });
replayFilterShareAllBtn.onclick = () => void applyReplayFilters({ shared: 'all' });
replayFilterShareSharedBtn.onclick = () => void applyReplayFilters({ shared: 'shared' });
replayFilterShareUnsharedBtn.onclick = () => void applyReplayFilters({ shared: 'unshared' });

async function applyOfficialModel(
  modelId: string,
  opts?: {
    switchToOfficialDefault?: boolean;
    gatewayId?: string | null;
  },
): Promise<void> {
  const id = String(modelId ?? '').trim();
  if (!id) return;
  const gatewayId = String(opts?.gatewayId ?? '').trim();
  const shouldSwitchToOfficial = opts?.switchToOfficialDefault === true && aiDefault.source !== 'official';
  setUiEnabled(false);
  statusEl.textContent = '正在更新官方模型…';
  if (shouldSwitchToOfficial) {
    statusEl.textContent = `正在切换到官方并使用 ${id}…`;
  } else {
    statusEl.textContent = `正在切换官方模型到 ${id}…`;
  }
  try {
    await setAiOfficialModel({ modelId: id, gatewayId: gatewayId || undefined });
    if (shouldSwitchToOfficial) {
      await setAiDefault({ source: 'official', profileId: null });
      await loadAiSettings();
      const activeModel = String(aiOfficial.model ?? '').trim();
      statusEl.textContent = activeModel ? `已切换到官方来源并使用：${activeModel}` : `已切换到官方来源并应用模型：${id}`;
      return;
    }
    await loadAiSettings();
    statusEl.textContent = `已切换模型：${id}`;
  } catch (err: unknown) {
    try {
      await loadAiSettings();
    } catch {
      // Ignore secondary refresh failure; preserve original update error.
    }
    statusEl.textContent = `更新失败：${String((err as any)?.message ?? err)}`;
  } finally {
    setUiEnabled(true);
  }
}

aiBillingRefreshBtn.onclick = async () => {
  setUiEnabled(false);
  statusEl.textContent = '正在刷新荐牌账单…';
  setPayActionStatus('正在刷新账单…');
  try {
    await loadAiBilling();
    statusEl.textContent = '已刷新荐牌账单。';
    setPayActionStatus('账单已刷新。');
  } catch (err: unknown) {
    statusEl.textContent = `刷新失败：${String((err as any)?.message ?? err)}`;
    setPayActionStatus(`账单刷新失败：${String((err as any)?.message ?? err)}`);
  } finally {
    setUiEnabled(true);
  }
};

payCreateOrderBtn.onclick = async () => {
  if (payConfigError) {
    statusEl.textContent = payConfigError;
    setPayActionStatus(payConfigError);
    return;
  }
  if (payMode !== 'xorpay') {
    statusEl.textContent = '当前为手动充值模式：请联系管理员。';
    setPayActionStatus('当前为手动充值模式，请联系管理员。');
    return;
  }
  const packageId = paySelectedPackageId.trim();
  const channel = paySelectedChannel;
  if (!packageId) {
    statusEl.textContent = '请先选择充值套餐。';
    setPayActionStatus('请选择充值套餐。');
    return;
  }
  if (channel !== 'alipay' && channel !== 'wechat_native') {
    statusEl.textContent = '请选择有效支付渠道。';
    setPayActionStatus('请选择有效支付渠道。');
    return;
  }

  setUiEnabled(false);
  setPayCreateLoading(true, '正在创建支付订单…');
  statusEl.textContent = '正在创建支付订单…';
  setPayActionStatus('正在创建支付订单…');
  try {
    const out = await createPayOrder({ packageId, channel });
    const order = out.order ?? null;
    if (!order) throw new Error('创建订单失败');
    payCurrentOrder = order;
    renderPaySection();
    statusEl.textContent = `支付订单已创建：${order.id}`;
    setPayActionStatus(`订单已创建：${order.id}`);
    if (order.payUrl) {
      if (!isDesktopPayView() && order.channel === 'alipay') {
        window.open(order.payUrl, '_blank', 'noopener,noreferrer');
      } else if (!isDesktopPayView() && order.channel === 'wechat_native') {
        statusEl.textContent = `支付订单已创建：${order.id}（微信请用另一台设备扫码）`;
        setPayActionStatus(`订单已创建：${order.id}（微信请用另一台设备扫码）`);
      }
    }
    if (!isFinalPayStatus(order.status)) {
      startPayPolling(order.id);
    }
    try {
      await loadAiBilling();
    } catch (billingErr: unknown) {
      console.warn('[pay] load billing after create failed', billingErr);
      statusEl.textContent = `支付订单已创建：${order.id}（账单刷新失败，可稍后手动刷新）`;
      setPayActionStatus(`订单已创建：${order.id}（账单刷新失败，可手动刷新）`);
    }
  } catch (err: unknown) {
    statusEl.textContent = `创建订单失败：${String((err as any)?.message ?? err)}`;
    setPayActionStatus(`创建订单失败：${String((err as any)?.message ?? err)}`);
  } finally {
    setPayCreateLoading(false);
    setUiEnabled(true);
  }
};

aiRulesSaveBtn.onclick = async () => {
  const text = aiRulesTextarea.value;
  if (!text.trim()) {
    statusEl.textContent = '保存失败：规则不能为空（如要恢复全局规则，请点“恢复跟随全局”）。';
    return;
  }
  setUiEnabled(false);
  aiRulesSaveBtn.disabled = true;
  aiRulesResetBtn.disabled = true;
  statusEl.textContent = '正在保存麻将规则模板…';
  try {
    await setAiRules(text);
    await loadAiRules();
    statusEl.textContent = '已保存麻将规则模板（自定义优先）。';
  } catch (err: unknown) {
    statusEl.textContent = `保存失败：${String((err as any)?.message ?? err)}`;
  } finally {
    aiRulesSaveBtn.disabled = false;
    aiRulesResetBtn.disabled = !aiRules.user;
    setUiEnabled(true);
  }
};

aiRulesResetBtn.onclick = async () => {
  if (!confirm('确定恢复跟随全局规则吗？你的自定义规则模板将被删除，且无法恢复。')) return;
  setUiEnabled(false);
  aiRulesSaveBtn.disabled = true;
  aiRulesResetBtn.disabled = true;
  statusEl.textContent = '正在恢复全局规则…';
  try {
    await setAiRules(null);
    await loadAiRules();
    statusEl.textContent = '已恢复跟随全局规则。';
  } catch (err: unknown) {
    statusEl.textContent = `恢复失败：${String((err as any)?.message ?? err)}`;
  } finally {
    aiRulesSaveBtn.disabled = false;
    aiRulesResetBtn.disabled = !aiRules.user;
    setUiEnabled(true);
  }
};

aiRulesTextarea.addEventListener('input', () => {
  updateAiRulesDraftMeta();
});

window.addEventListener('beforeunload', (e) => {
  stopPayPolling();
  if (aiRulesDirty) {
    e.preventDefault();
    e.returnValue = '';
  }
});

async function bootstrap(): Promise<void> {
  try {
    const existing = getLoginToken();
    statusEl.textContent = existing ? '正在加载账号信息…' : '首次访问：正在为你创建账号…';
    setUiEnabled(false);

    const { created, loginToken, apiToken, user } = await ensureUser();
    currentUser = user;
    selectedAvatarIndex = normalizePresetAvatarIndex(user.avatarIndex);
    nickInput.value = user.nickname;
    renderMatchPoints();
    bgmEnabledInput.checked = user.bgmEnabled !== false;
    sfxEnabledInput.checked = user.sfxEnabled !== false;
    loginTokenInput.value = loginToken;
    renderAvatarSection();
    statusEl.textContent = created ? `已创建账号：${user.nickname}` : `已登录：${user.nickname}`;
    contentEl.style.display = 'block';
    scheduleMeCanvasScale();

    if (created) {
      openModal(
        '已为你创建账号',
        '请立即复制保存。API Token 仅展示一次，丢失只能重置。',
        (() => {
          const wrap = document.createElement('div');
          wrap.className = 'field';
          wrap.appendChild(buildCopyField(loginToken, '登录口令'));
          if (apiToken) {
            wrap.appendChild(buildCopyField(apiToken, 'API Token（仅展示一次）'));
          }
          return wrap;
        })()
      );
    }
    initializeTabs();
    const initialTab = parseMeTabFromHash();
    await switchMeTab(initialTab);
  } catch (err: unknown) {
    statusEl.textContent = `加载失败：${String((err as any)?.message ?? err)}（你可以回到首页重新登录）`;
    contentEl.style.display = 'none';
  } finally {
    setUiEnabled(true);
  }
}

bootstrap();
